/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-named-as-default-member */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { Form, Button } from 'semantic-ui-react'

import RestaurantActions from '../../../reducers/restaurantReducer'

import Loading from '../../common/loading'

import NameField from '../fields/nameField'
import PreparationField from '../fields/preparationField'
import TierField from '../fields/tierField'
import PublishField from '../fields/publishField'
import VatField from '../fields/vatField'
import CommissionField from '../fields/commissionField'
import RatingField from '../fields/ratingField'
import VisibilityField from '../fields/imageVisibilityField'
import NoteField from '../fields/noteField'
import TagsField from '../fields/tagsField'
import SearchKeywordsField from '../fields/searchKeywordsField'
import CategoriesField from '../fields/categoriesField'
import RestrictedAgeField from '../fields/restrictedAgeField'
import MerchantTypeField from '../fields/merchantTypeField'
import MarkUpPercentageField from '../fields/markUpPercentageField'
import ReferenceMerchantField from '../fields/referenceMerchantField'

const initialData = {
  name: '',
  phone: '',
  note: '',
  status: 'draft',
  rate: 0,
  vat: 0,
  tier: 0,
  cooking_duration: 0,
  discount_rate: 0,
  tags: [],
  categories: {},
  restricted_age: false,
  merchant_type: 'f-and-b',
  hide_item_image: false,
  mark_up_percentage: 0,
  reference_merchant_id: null,
  search_keywords: []
}

class RestaurantForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      storeId: props.firebaseKey,
      store: initialData,
    }
  }

  componentDidMount() {
    const { editRestaurant } = this.props

    this.initStoreData(editRestaurant)
  }

  componentWillReceiveProps(nextProps) {
    const { editRestaurant } = this.props

    if (nextProps.editRestaurant !== editRestaurant && nextProps.editRestaurant) {
      this.initStoreData(nextProps.editRestaurant)
    }
  }

  initStoreData = store => {
    this.setState({ store: { ...initialData, ...store } })
  }

  onFieldChange = (field, value) => {
    const { store } = this.state

    store[field] = value

    this.setState({ store })
  }

  onCategoriesChange = (key, checked) => {
    const { store } = this.state
    let newCategories

    if (checked) {
      newCategories = { ...store.categories, [key]:  checked }
    } else {
      newCategories = _.pickBy(store.categories, (cat, catKey) => catKey !== key)
    }

    this.setState({ store: { ...store, categories: newCategories } })
  }

  onTagsChange = selectedTags => {
    const { store } = this.state

    const tags = _.transform(
      selectedTags,
      (result, tag) => {
        result[tag] = (store.tags && store.tags[tag]) || true
      },
      {}
    )

    this.setState({ store: { ...store, tags } })
  }

  onKeywordsChange = keywords => {
    const { store } = this.state
    this.setState({ store: {...store, search_keywords: keywords}})
  }

  onSubmit = e => {
    e.preventDefault()

    const { store, storeId } = this.state
    const { history, saveRestaurant } = this.props

    saveRestaurant(storeId, store, () => {
      history.push({
        pathname: `/restaurants/detail/${storeId}`,
      })
    })
  }

  render() {
    const { loading, action, permissions } = this.props
    const { store } = this.state

    const disabledCommission = action === 'Edit' && !permissions.includes('edit_merchant_commission')

    return (
      <div>
        <Loading active={loading} />
        <Form onSubmit={this.onSubmit}>
          <Form.Group widths="equal">
            <NameField onChange={this.onFieldChange} value={store.name} />
            <PreparationField onChange={this.onFieldChange} value={store.cooking_duration} />
          </Form.Group>
          <Form.Group widths="equal">
            <TierField onChange={this.onFieldChange} value={store.tier} />
            <PublishField onChange={this.onFieldChange} value={store.status} />
          </Form.Group>
          <Form.Group widths="equal">
            <VatField onChange={this.onFieldChange} value={store.vat} />
            <CommissionField
              required
              disabled={disabledCommission}
              onChange={this.onFieldChange}
              field='discount_rate'
              value={store.discount_rate}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <RatingField onChange={this.onFieldChange} value={store.rate} />
            <VisibilityField onChange={this.onFieldChange} value={store.hide_item_image} />
          </Form.Group>
          <Form.Group widths="equal">
            <MerchantTypeField onChange={this.onFieldChange} value={store.merchant_type} />
            <RestrictedAgeField onChange={this.onFieldChange} value={store.restricted_age} />
          </Form.Group>
          <Form.Group widths="equal">
            <ReferenceMerchantField onChange={this.onFieldChange} value={store.reference_merchant_id} />
            <MarkUpPercentageField onChange={this.onFieldChange} value={store.mark_up_percentage} />
          </Form.Group>
          <Form.Group widths="equal">
            <TagsField
              onChange={this.onTagsChange}
              multiple
              value={_.map(store.tags, (tag, tagKey) => tagKey)}
            />
            <SearchKeywordsField
              onChange={this.onKeywordsChange}
              multiple
              value={store.search_keywords}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <NoteField onChange={this.onFieldChange} value={store.note} />
          </Form.Group>

          <CategoriesField onChange={this.onCategoriesChange} value={store.categories} />
          <Button color="black" type="submit">
            Save
          </Button>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = ({ auth, restaurants, rolePermission }) => ({
  loading: restaurants.loading,
  permissions: rolePermission.roles[auth.data.role].access,
})

const mapDispatchToProps = dispatch => ({
  saveRestaurant: (key, params, callback) =>
    dispatch(RestaurantActions.saveRestaurantRequest(key, params, callback)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RestaurantForm))



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/storeForm.js